import * as React from "react";
import { JSX } from "react/jsx-runtime";
const CompactIcon = ({
  color = "#ddd",
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width="90"
    height="44"
    viewBox="0 0 92 46"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="1"
      y="1"
      width="90"
      height="44"
      rx="6"
      ry="6"
      fill="none"
      stroke={color}
      strokeWidth="1"
    />
    <rect
      x="8"
      y="11"
      width="10"
      height="10"
      rx="2"
      ry="2"
      fill="none"
      stroke={color}
      strokeWidth="1"
    />
    <rect
      x="8"
      y="26"
      width="10"
      height="10"
      rx="2"
      ry="2"
      fill="none"
      stroke={color}
      strokeWidth="1"
    />
    <rect x="26" y="14" width="58" height="5" rx="2" fill={color} />
    <rect x="26" y="29" width="58" height="5" rx="2" fill={color} />
  </svg>
);
export default CompactIcon;
